// Used for dropdown / Radio Button
export const ExportFileTypes = [{
    value: 'csv',
    label: 'CSV',
    tooltip: ''
},
{
    value: 'xlsx',
    label: 'XLSX',
    tooltip: ''
}
    // {
    //     value: 'xls',
    //     label: 'XLS',
    //     tooltip: 'common.tooltips.uploadFiles.fileDoesNotSupportedForImport'
    // }
]